import store from "../redux/store.ts";

import { app } from "./app";
import lFindIndex from "lodash/findIndex";

export const contacts = {
  haveContacts: (status) => {
    store.dispatch({
      type: "HAVE_CONTACTS",
      payload: {
        haveContacts: status,
      },
    });
  },
  columnSize: (data) => {
    store.dispatch({
      type: "COLUMN_SIZE",
      payload: {
        columnSize: data,
      },
    });
  },

  getRecentImports: async () => {
    if (!leftSideSelectors.isContact(store.getState())) {
      contacts.loadContactsList([]);
    }
    try {
      const response = await api.getRecentImportsApi();
      const formatResponse = mapping.buildRecentImports(
        response.data ? response.data : []
      );
      store.dispatch({
        type: "RECENT_IMPORTS",
        payload: {
          imports: response.data,
        },
      });
      contacts.loadContactsList(formatResponse);
    } catch (error) {
      store.dispatch({
        type: "RECENT_IMPORTS",
        payload: {
          imports: [],
        },
      });
      contacts.loadContactsList([]);
      helpersFunc.logEnjectServicePromise(error);
    }
  },

  typeContacts: (data) => {
    store.dispatch({
      type: "TYPE_CONTACTS",
      payload: {
        typeContacts: data,
      },
    });
  },
  typeCampaigns: (data) => {
    store.dispatch({
      type: "TYPE_CAMPAIGNS",
      payload: {
        typeCampaigns: data,
      },
    });
  },

  changeContactsPage: (page) => {
    store.dispatch({
      type: "CONTACTS_PAGE",
      payload: {
        contactsPage: page,
      },
    });
  },

  clearContacts: () => {
    store.dispatch({
      type: "ALL_CONTACTS",
      payload: {
        contacts: [],
      },
    });
    store.dispatch({
      type: "CONTACTS_COUNT",
      payload: {
        contactsCount: 0,
      },
    });

    store.dispatch({
      type: "HAVE_CONTACTS",
      payload: {
        haveContacts: false,
      },
    });
  },
  cancelExecution: (data) => {
    store.dispatch({
      type: "ALL_CONTACTS",
      payload: {
        contacts: data,
      },
    });
    app.changeTableContentLoaderStatus(false);
  },
  updateImportedContact: (data) => {
    const tempImports = store.getState().contacts.imports;
    const index = lFindIndex(tempImports, {
      id: data.id,
    });
    tempImports.splice(index, 1, data);
    store.dispatch({
      type: "UPDATE_IMPORTED_CONTACT",
      payload: {
        imports: tempImports,
      },
    });
  },
};
